import { FC, useState } from 'react';

import { FieldsFilterState, FieldsFilterContext } from './filter';

export const FieldsFilterProvider: FC<React.PropsWithChildren<unknown>> = ({ children }) => {
  const [search, changeSearch] = useState('');

  const context: FieldsFilterState = {
    changeSearch,
    search,
  };

  return <FieldsFilterContext.Provider value={context}>{children}</FieldsFilterContext.Provider>;
};
